import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import React, { useState } from 'react';
import ClickAwayListener from '@mui/base/ClickAwayListener';

import ISelectOption from './interfaces/ISelectOption';

interface ISelectChexbox {
  options: ISelectOption[];
  selectds: ISelectOption[];
  onChange: (selecteds: ISelectOption[]) => void;
  limitTags?: number;
  size?: 'small' | 'medium';
  label: string;
}

const SelectCheckbox = (props: ISelectChexbox) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleChange = (option: ISelectOption) => {
    if (props.selectds.map(s => s.value).indexOf(option.value) !== -1) {
      props.onChange(props.selectds.filter(selected => selected.value !== option.value));
    } else {
      props.onChange([...props.selectds, option]);
    }
  };
  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <FormControl sx={{ width: '100%' }} size={props.size}>
        <InputLabel>{props.label}</InputLabel>
        <Select
          open={isOpen}
          multiple
          size={props.size}
          value={props.selectds}
          input={<OutlinedInput label={props.label} onClick={() => setIsOpen(!isOpen)} />}
          renderValue={selecteds => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selecteds.map((selected: ISelectOption, indx: number) => {
                if (indx < 2) {
                  return (
                    <Chip key={indx} label={selected.label} size={props.size} onDelete={() => handleChange(selected)} />
                  );
                } else {
                  return <></>;
                }
              })}
              {selecteds.length > 2 && `+${selecteds.length - 2}`}
            </Box>
          )}
        >
          {props.options.map(option => (
            <MenuItem
              key={option.value}
              value={option.label}
              onClick={e => {
                handleChange(option);
                e.stopPropagation();
              }}
            >
              <Checkbox checked={props.selectds.map(s => s.value).indexOf(option.value) !== -1} key={option.value} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ClickAwayListener>
  );
};

export default SelectCheckbox;
